import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import "./SearchFilter.css";

const SearchBar = ({
  value = "",
  onChange,
  placeholder = "Search...",
  className = "",
  debounce = 300,
  ariaLabel = "Search",
}) => {
  const [draftValue, setDraftValue] = useState(value || "");

  useEffect(() => {
    setDraftValue(value || "");
  }, [value]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (draftValue !== value && onChange) onChange(draftValue);
    }, debounce);

    return () => window.clearTimeout(timer);
  }, [debounce, draftValue, onChange, value]);

  const clearSearch = () => {
    setDraftValue("");
    if (onChange) onChange("");
  };

  return (
    <div className={`zarp-searchbar ${className}`.trim()}>
      <Search size={18} className="zarp-searchbar-icon" />
      <input
        value={draftValue}
        onChange={(event) => setDraftValue(event.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {draftValue && (
        <button type="button" className="zarp-searchbar-clear" onClick={clearSearch} aria-label="Clear search">
          <X size={14} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
